import { Grid } from "@material-ui/core";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import WithLoading from "../../../../utils/WithLoading";
import DashboardDetailsCard from "./DashboardDetailsCard";
import costOfRewards from "../../../../assets/images/logos/cost-of-rewards.png";
import costSpendRatio from "../../../../assets/images/logos/cost-spend-ratio.png";
import expiredStamps from "../../../../assets/images/logos/expired-stamps.png";
import rewardsRedeemed from "../../../../assets/images/logos/rewards-redeemed.png";
import stampsEarned from "../../../../assets/images/logos/stamps-earned.png";
import totalSpend from "../../../../assets/images/logos/total-spend.png";


export interface DashboardDetailsInfoNodeProps {
  isLoading: any;
  performanceNodeList: any;
}

/*
 * DashboardDetailsInfoNode is a React functional component responsible for rendering
 * a grid of dashboard details cards. It receives isLoading, currentSalesTotal, and
 * previousSalesTotal as props, and based on these props, it generates a list of sales
 * total details to be displayed on each card. It also utilizes WithLoading HOC to handle
 * loading states. The component maps over the salesTotalNode list and renders a
 * DashboardDetailsCard component for each item in the list.
 */
const DashboardDetailsInfoNode: React.FunctionComponent<
  DashboardDetailsInfoNodeProps
> = ({ isLoading, performanceNodeList }) => {
  const [salesTotalNode, setSalesTotalNode] = useState<any>([]);

  /* Using the data from the API call, lists the icon, amount name, current amount, 
  and previous amount to be displayed on each card. */
  useEffect(() => {
    let saleTotalList: any = [];
    saleTotalList.push(
      {
        title: "STAMPS EARNED OVER TIME",
        currentAmount: performanceNodeList?.[0]?.["totalStampsEarned"] || 0,
        img: stampsEarned
      },
      {
        title: "REWARDS REDEEMED",
        currentAmount: performanceNodeList?.[0]?.["totalRewardsRedeemed"] || 0,
         img: rewardsRedeemed
      },
      {
        title: "TOTAL CUSTOMER SPEND",
        currentAmount: performanceNodeList?.[0]?.["totalSpend"] || 0,
         img: totalSpend
      },
      {
        title: "COST OF REWARDS",
        currentAmount: performanceNodeList?.[0]?.["totalRewardCost"] || 0,
         img: costOfRewards
      },
      {
        title: "COST-TO-SPEND RATIO",
        currentAmount: (() => {
          const rewardCost = performanceNodeList?.[0]?.["totalRewardCost"] || 0;
          const spend = performanceNodeList?.[0]?.["totalSpend"] || 0;
          const ratio = spend !== 0 ? (rewardCost / spend) * 100 : 0;
          return `${ratio % 1 === 0 ? ratio : parseFloat(ratio.toFixed(1))}%`;
        })(),
         img: costSpendRatio
      },
      {
        title: "Total Non-Eligible Orders",
        currentAmount: performanceNodeList?.[0]?.["totalNonEligibleOrder"] || 0,
         img: expiredStamps
      },
    );
    setSalesTotalNode(saleTotalList);
  }, [performanceNodeList]);
  return (
    <>
      <Grid container spacing={2} style={{ marginTop: "12px" }}>
        {salesTotalNode.map((data: any) => {
          return (
            <Grid item xs={6} md={4}>
              <DashboardDetailsCard salesTotalObject={data} />
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};

export default WithLoading(DashboardDetailsInfoNode, "text");
